<template>
  <div class="flex items-center" v-if="hasImage">
    <div style="height: 60px; width: 60px;">
      <img :src="image" width="60"/>
    </div>
  </div>
</template>

<script>
  import router from '@/router'
  export default {
    name: 'CellRendererLink',
    computed: {
      hasImage() {
        return (this.$data.data[this.$data.data.column.image].trim() != '');
      },
      image() {
        return 'data:image/jpeg;charset=utf-8;base64,' + this.$data.data[this.$data.data.column.image];
      },
      altImage() {
        return this.$data.data[this.$data.data.column.altImage];
      },
      routeName() {
        return `${this.$data.data.column.routeName}`
      }
    },
    methods: {
      route() {
        // router.push({path: this.url, params: {id: this.$data.data.id}})
        router.push({name: this.routeName, params: {id: this.$data.data.id}})
      }
    }
  }
</script>
